<p-dialog [(visible)]="showMiscDialog" [style]="{width: '500px'}" [modal]="true" [draggable]="false"
[resizable]="false" [header]="isEditMode ? 'Edit Misc Task' : 'Add Misc Task'">

<div class="flex flex-column w-full">
  <!-- Content -->
  <div class="flex flex-column gap-4 p-4">
    <!-- Task Input - hidden in time-only mode -->
    <div *ngIf="!timeOnlyMode" class="flex flex-column gap-2">
      <label for="task" class="text-sm font-medium text-900">Task Description</label>
      <textarea pInputTextarea [(ngModel)]="miscDescription">
            </textarea>
    </div>

    <!-- Time Input -->
    <div class="flex flex-column gap-2">
      <label for="time" class="text-sm font-medium text-900">Time</label>
      <p-calendar [(ngModel)]="miscTime" [timeOnly]="true" [showIcon]="true" inputId="time"
        [showSeconds]="false" hourFormat="12" placeholder="Select time" styleClass="w-full">
      </p-calendar>
    </div>
  </div>

  <!-- Footer -->
  <div class="flex align-items-center justify-content-end gap-2 p-4 border-top-1 surface-border">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text"
      (click)="cancelMiscDialog()">
    </button>
    <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="(!timeOnlyMode && !miscDescription) || !miscTime"
      class="p-button-raised" (click)="saveMiscTask()">
    </button>
  </div>
</div>
</p-dialog>
